import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, CancelarPlacaPrimeiroEmplacamento } from './types';

export const INITIAL_STATE: CancelarPlacaPrimeiroEmplacamento = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): CancelarPlacaPrimeiroEmplacamento {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CANCELAR_PLACA_PRIMEIRO_EMPLACAMENTO_REQUEST: {
				break;
			}

			case Types.CANCELAR_PLACA_PRIMEIRO_EMPLACAMENTO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CANCELAR_PLACA_PRIMEIRO_EMPLACAMENTO_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.CANCELAR_PLACA_PRIMEIRO_EMPLACAMENTO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
